
import CloseIcon from '@mui/icons-material/Close';
import BackspaceIcon from '@mui/icons-material/Backspace';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import WarningIcon from '@mui/icons-material/Warning';

import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getUserByPin, picarEvento } from '../../services/api.service';
import toast from 'react-hot-toast';

function Button({ number, pin, onClick }: { number: number, pin: string, onClick: () => void }) {

    const disabled = pin.length == 4;

    return (
        <div onClick={onClick}
            className={`p-3  flex items-center justify-center rounded shadow-md border mt-4 ${!disabled ? 'hover:shadow-lg hover:border-rodrimaq-red cursor-pointer' : 'bg-zinc-200 opacity-50'} `}>
            <div>{number.toString()}</div>
        </div>
    )
}


export function ModalPin({ close, dataPicagem, evento }: { close: () => void, dataPicagem: Date, evento: string }) {

    const [pin, setPin] = useState('');
    const [visible, setVisible] = useState(false);
    const [utilizador, setUtilizador] = useState<any>(null);

    const handleClick = (n: number) => {
        if (pin.length < 4) {
            setPin((cp) => cp + n)
        }
    }

    const confirmationDisabled = !(pin.length === 4);

    const { refetch } = useQuery({
        queryKey: ['utilizadoresPorPin'],
        queryFn: async () => {
            if (!confirmationDisabled) return await getUserByPin(pin)
            return null;
        },
        onSuccess: (data: any) => {
            setUtilizador(data);
        },
        onError: () => {
            toast.error('Não foi possível associar o PIN a um utilizador, por favor volta a tentar');
            setPin('');
        }
    })

    const confirmMutation = useMutation([utilizador?.id], () => picarEvento(evento, { userId: utilizador?.id, data: dataPicagem }), {
        onSuccess: () => {
            close();
            toast.success(`${evento} registado com sucesso!`)
        },
        onError: (err : any) => {
            toast.error(err?.response?.data?.message, {
                duration: 6000
            })
        }
    });


    return (
        <>
            <div className="absolute flex w-full h-full top-0 left-0 items-center content-center justify-center bg-zinc-300 bg-opacity-60 z-10">
                <div className={`relative flex flex-col bg-white h-fit w-fit opacity-100 z-20 rounded-md p-3`}>


                    {
                        utilizador ? <>
                            <div className={`relative flex flex-col bg-white h-fit w-fit opacity-100 z-20 rounded-md p-3`}>
                                <span className='font-bold'>{utilizador.name}</span> a dar {evento.toLocaleLowerCase()} a {dataPicagem.toLocaleString('pt')}
                            </div>
                            <div className="flex w-full justify-between">
                                <button className='border p-2 hover:bg-rodrimaq-red' onClick={() => setUtilizador(null)}>Cancelar</button>
                                <button className='border p-2 hover:bg-rodrimaq-red' onClick={() => confirmMutation.mutate()}>Confirmar</button>
                            </div>
                        </> :
                            <div className='w-96'>

                                <div className="w-full flex justify-end">
                                    <CloseIcon onClick={close} />
                                </div>
                     
                                <div className='p-5 flex flex-col w-full h-full'>
                                    <div className='border rounded shadow-inner flex w-full h-10 px-4 justify-between items-center text-xl'>
                                        {visible ? <VisibilityOffIcon
                                            onClick={() => setVisible(false)}
                                            className='text-zinc-400' /> : <VisibilityIcon
                                            className='text-zinc-400'
                                            onClick={() => setVisible(true)}
                                        />}
                                        {visible ? pin : pin.split('').map(() => '*')}
                                        <BackspaceIcon className='text-zinc-400' onClick={() => setPin((p) => {
                                            return p.slice(0, p.length - 1);
                                        })} />
                                    </div>
                                    <div className='grid grid-cols-3 gap-4 h-full'>
                                        <div>
                                            <Button pin={pin} onClick={() => handleClick(1)} number={1} />
                                            <Button pin={pin} onClick={() => handleClick(4)} number={4} />
                                            <Button pin={pin} onClick={() => handleClick(7)} number={7} />
                                        </div>
                                        <div>
                                            <Button pin={pin} onClick={() => handleClick(2)} number={2} />
                                            <Button pin={pin} onClick={() => handleClick(5)} number={5} />
                                            <Button pin={pin} onClick={() => handleClick(8)} number={8} />
                                        </div>
                                        <div>
                                            <Button pin={pin} onClick={() => handleClick(3)} number={3} />
                                            <Button pin={pin} onClick={() => handleClick(6)} number={6} />
                                            <Button pin={pin} onClick={() => handleClick(9)} number={9} />
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <button
                                            onClick={() => refetch()}
                                            disabled={confirmationDisabled}
                                            className={`p-2 border rounded flex w-full justify-center ${!confirmationDisabled ? 'hover:bg-rodrimaq-red hover:text-white border-rodrimaq-red' : 'bg-zinc-200'}`}>
                                            <div >Confirmar</div></button>
                                    </div>
                                </div>
                            </div>
                    }


                </div>
            </div>
        </>
    )

}